<!-- <script setup lang="ts">
import { ref } from 'vue'
import { FormInst } from 'naive-ui'
import { useMessage, MessageReactive } from 'naive-ui'
import { useSessionStore } from '../stores/session'
import { useRoute } from 'vue-router'
import { getTokens } from '../composables'
import * as Sentry from "@sentry/vue";

const route = useRoute()
const formRef = ref<FormInst | null>(null)

const model = ref({
    textareaValue: null,
})

let msgReactive: MessageReactive | null = ref(null)
const store = useSessionStore()
const message = useMessage()

const onReset = function () {
    model.value.textareaValue = ''
}

const onSend = function () {
    submitFeedback()
}

const submitFeedback = async function () {
    msgReactive = message.loading(
        "Feedback wird versendet...",
        {
            closable: true,
            duration: 0
        }
    )

    const body = {
        userId: store.userId,
        email: store.userEmail,
        article: route.path,
        helpful: '',
        feedback: model.value.textareaValue
    }

    const { accessToken } = getTokens();
    try {
        const response = await fetch(`https://support.arenae.ch/wp-json/arenae/v1/feedback?access_token=${accessToken}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
        })
        if (response.ok) {
            message.success('Senden erfolgreich')
            model.value.textareaValue = null
        } else {
            message.error('Senden fehlgeschlagen')
            Sentry.captureException(new Error("Send feedback: Response not ok."));
        }
    } catch (error) {
        message.error('Senden fehlgeschlagen')
        Sentry.captureException(error);
    } finally {
        if (msgReactive) {
            msgReactive.destroy()
            msgReactive = null;
        }
        gtag('event', `faq_form_sent`, { 'event_category': 'faq_form' });
    }
}
</script>

<template>
    <div>
        <n-form ref="formRef" :model="model" label-placement="top">
            <n-grid :span="24" :x-gap="24">
                <n-form-item-gi :span="24" label="" path="textareaValue">
                    <n-input v-model:value="model.textareaValue" placeholder="Optional" type="textarea" :autosize="{
                        minRows: 3,
                        maxRows: 50
                    }" />
                </n-form-item-gi>
                <n-gi :span="24">
                    <n-space>
                        <n-button type="primary" @click="onSend">
                            absenden
                        </n-button>
                        <n-button @click="onReset">
                            zurücksetzen
                        </n-button>
                    </n-space>
                </n-gi>
            </n-grid>
        </n-form>
    </div>
</template>

<style scoped>
.flex {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.separator {
    margin-top: 4em;
}

.n-button.active {
    color: var(--n-text-color-hover);
}
</style> -->

<script setup lang="ts">
import { useAuth0 } from '@auth0/auth0-vue';
const { user } = useAuth0();

</script>

<template>

    <div v-if="user">
        Dann schick uns doch eine kurze Mail an <a href="mailto:info@arenae.ch">info@arenae.ch</a>
    </div>
</template>
